import { render, staticRenderFns } from "./DataExportsPage.vue?vue&type=template&id=29b30364&scoped=true&"
import script from "./DataExportsPage.vue?vue&type=script&lang=ts&"
export * from "./DataExportsPage.vue?vue&type=script&lang=ts&"
import style0 from "./DataExportsPage.vue?vue&type=style&index=0&id=29b30364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b30364",
  null
  
)

export default component.exports